

















































































import { Component, Prop } from 'vue-property-decorator'

import UserInfoHelper from '../../../../../Helpers/UserInfoHelper'
import ConstantValue from '../../../../Branching/ConditionsNode/logic/PropertyConditionValues/ConstantValue'
import PropertyValue from '../../../../Branching/ConditionsNode/logic/PropertyConditionValues/PropertyValue';
import { SampleNodeMixin } from '../../../../index'
import { RunFlowNode } from '../../logic/RunFlowNode'

@Component({
  data() {
    return {
      PropertyValue,
      ConstantValue
    }
  }
})
export default class RunFlowSampleNode extends SampleNodeMixin {
  @Prop() node!: RunFlowNode

  get property() {
    if (this.node.data.target instanceof PropertyValue) {
      const prop = this.node.stringTypeProperties.find(p => p.id === (this.node.data.target as PropertyValue).property_index)

      if (prop) {
        return prop.name
      } else {
        return null
      }
    }

    return ''
  }

  get user() {
    if (this.node.data.target instanceof ConstantValue && this.node.data.target.value) {
      const user = UserInfoHelper.getUser(this.node.data.target.value)

      if (user) {
        return user.info.name
      }

      return null
    }

    return ''
  }

  get flowTitle(): string | undefined {
    const flow = this.node.nodeProps.getFlows().find((f) => f.value === this.node.data.token)

    if (flow) {
      return flow.label
    }
    return undefined
  }
}
